const mapSize = (map, module) => {
  const mapHeight = map.offsetHeight;
  // eslint-disable-next-line no-param-reassign
  module.style.minHeight = `${mapHeight}px`;
};

const scrollToItem = (item) => {
  setTimeout(() => {
    window.scrollTo({
      top: item,
      left: 0,
      behavior: 'smooth',
    });
  }, 200);
};

const mapModule = document.querySelector('.sc-map-module');
if (mapModule) {
  const mapModuleOffset = mapModule.getBoundingClientRect().top + document.documentElement.scrollTop;
  const mapEu = mapModule.querySelector('.map-module__eu');
  const mapImg = mapEu.querySelector('.map-module__eu-placeholder');
  const countries = mapModule.querySelectorAll('.dropdown__list-option');
  const fakeMap = mapModule.querySelector('.map-module__eu-map');
  const allMapTypes = mapModule.querySelectorAll('.map-module__type');
  const mapTypes = mapModule.querySelectorAll('.map-module__type');
  const popupList = mapModule.querySelectorAll('[data-popup-country]');
  const allCountries = mapModule.querySelectorAll('.map-module__country');
  const allPopups = mapModule.querySelectorAll('.map-module__popup-item');
  const allPoints = mapModule.querySelectorAll('.map-module__point');

  const toggleHiddenClass = (elements, toggle) => {
    elements.forEach((item) => {
      item.classList.toggle('is-hidden', toggle);
    });
  };

  const toggleActiveClass = (elements, toggle) => {
    elements.forEach((item) => {
      item.classList.remove('is-active');
    });
  };

  const resetFilter = () => {
    toggleActiveClass(mapTypes, false);
    toggleActiveClass(allPoints, false);
    toggleHiddenClass(allPopups, false);
  };

  const loadLocalMap = (country) => {
    const countryAttr = country.getAttribute('data-country');
    if (countryAttr !== 'all') {
      const selectedPopupList = mapModule.querySelector(`[data-popup-country="${countryAttr}"]`);
      const typeFilter = mapModule.querySelector('.map-module__types');

      mapEu.removeAttribute('class');
      mapEu.classList.add('map-module__eu');

      // Show filter
      typeFilter.classList.add('is-active');

      // Reset filter
      resetFilter();

      allCountries.forEach((otherCountry) => {
        otherCountry.classList.remove('is-active');
        otherCountry.classList.add('is-hidden');
      });

      const target = mapModule.querySelector(`.map-module__${countryAttr}`);
      const targetWithPoints = mapModule.querySelector(`.map-module__${countryAttr}.map-with-points`);

      fakeMap.classList.add('is-hidden');

      mapEu.classList.add(`${countryAttr}`);
      targetWithPoints.classList.remove('is-hidden');
      targetWithPoints.classList.add('is-active');
      target.classList.remove('is-hidden');
      target.classList.add('is-active');

      allPopups.forEach((allPopup) => {
        setTimeout(() => {
          allPopup.classList.remove('is-visible');
        }, 0);
        setTimeout(() => {
          allPopup.classList.remove('is-active');
        }, 300);
      });

      allPoints.forEach((point) => {
        point.classList.remove('is-open');
      });

      // Open card list of selected country
      toggleActiveClass(popupList, false);
      selectedPopupList.classList.add('is-active');
    } else {
      allCountries.forEach((otherCountry) => {
        otherCountry.classList.remove('is-hidden');
        otherCountry.classList.remove('is-active');
      });

      mapEu.removeAttribute('class');
      mapEu.classList.add('map-module__eu');

      fakeMap.classList.remove('is-hidden');

      allPopups.forEach((allPopup) => {
        allPopup.classList.remove('is-visible');
        setTimeout(() => {
          allPopup.classList.add('is-active');
        }, 300);
      });

      // Open card list of selected country
      toggleActiveClass(popupList, false);
      // selectedPopupList.classList.remove('is-active');
    }
  };

  mapImg.onload = () => {
    const debounceSize = debounce(() => {
      mapSize(mapEu, mapModule);
    }, 300);

    mapSize(mapEu, mapModule);
    window.addEventListener('resize', () => {
      debounceSize();
    });
  };

  // Country select box
  countries.forEach((country) => {
    country.addEventListener('click', () => {
      loadLocalMap(country);

      if (windowWidth() < breakpointMd) {
        scrollToItem(mapModuleOffset);
      }
    });
  });

  const currentCountry = mapModule.querySelector('.dropdown');
  if (currentCountry.getAttribute('data-country')) {
    loadLocalMap(currentCountry);
  }

  // Map types buttons and pins
  mapTypes.forEach((mapType) => {
    mapType.addEventListener('click', () => {
      toggleActiveClass(allMapTypes, false);
      mapType.classList.add('is-active');

      const pointAttr = mapType.getAttribute('data-map-type');
      allPoints.forEach((point) => {
        point.classList.remove('is-active');
        point.classList.remove('is-open');
      });

      const targets = mapModule.querySelectorAll(`.map-module__point.${pointAttr}`);
      toggleActiveClass(targets, true);

      if (windowWidth() < breakpointMd) {
        scrollToItem(mapModuleOffset);
      }

      // Show hide card according to selected option
      toggleHiddenClass(allPopups, true);
      const targetPopups = mapModule.querySelectorAll(`[data-popup-type*="${pointAttr}"]`);
      toggleHiddenClass(targetPopups, false);
    });
  });
}
